import React, { PropTypes, Component } from 'react';
import { browserHistory } from 'react-router';
import { menuItems } from '../../../../defaults/menuItems';

const propTypes = {
  locale: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  children: PropTypes.string,
  onLocaleChange: PropTypes.func.isRequired,
};

class Item extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { language } = this.props;

    this.props.onLocaleChange(language);

    // Save to local storage and change url
    let url;
    switch (language) {
      case 'pt':
        url = menuItems[0].pt;
        break;
      case 'es':
        url = menuItems[0].es;
        break;
      default:
        url = menuItems[0].en;
    }

    localStorage.setItem('locale', language); // eslint-disable-line no-undef
    browserHistory.push(url);
  }

  render() {
    const { locale, language, children } = this.props;
    const buttonClass = locale === language
    ? 'ui active blue button'
    : 'ui button';

    return (
      <a onClick={this.handleClick} className={buttonClass}>
        {children}
      </a>
    );
  }
}

Item.propTypes = propTypes;

export default Item;



/** WEBPACK FOOTER **
 ** ./src/components/layout/nav/locale/Item.js
 **/